import { jsx as _jsx } from "react/jsx-runtime";
import '@streamr/tv-ui/dist/tv-ui.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { initServices } from './services/initServices';
import { RECORDING_SW_SCOPE } from './sw/recordingPlaybackProtocol';
import { initPeerDiagnosticsPage } from './utils/peerDiagnosticsPage';
import { initRemoteLogger } from './utils/remoteLogger';
import { installRtcDiagnostics } from './utils/rtcDiagnostics';
import { initSentry } from './utils/sentry';
/**
 * The frame of a recording player shows a document that the recording
 * service worker makes. Without the worker the request reaches the server,
 * which answers with the app, as it does for every path. The app has no
 * business in that frame: it tells the page, which brings the worker back.
 */
function tellIfLoadedInPlaceOfRecordingPlayer() {
    if (window.parent === window ||
        !window.location.pathname.startsWith(RECORDING_SW_SCOPE)) {
        return false;
    }
    const token = window.location.pathname
        .slice(RECORDING_SW_SCOPE.length)
        .split('/')[0];
    window.parent.postMessage({ type: 'recording-player-unserved', token }, window.location.origin);
    return true;
}
async function bootstrap() {
    initRemoteLogger();
    initPeerDiagnosticsPage();
    initSentry();
    installRtcDiagnostics();
    try {
        await initServices();
    }
    catch (error) {
        console.error('Error initializing services', error);
        return;
    }
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(_jsx(App, {}));
    reportWebVitals();
}
if (!tellIfLoadedInPlaceOfRecordingPlayer()) {
    // biome-ignore lint/nursery/noFloatingPromises: TODO
    bootstrap();
}
